module.exports = __webpack_public_path__ + "static/media/check.c5b2323a.svg";